import { create } from 'zustand';

export type TabId = 'maths' | 'english' | 'other';

interface ReportState {
  activeTab: TabId;
  setActiveTab: (tab: TabId) => void;
}

export const useReportStore = create<ReportState>((set) => ({
  activeTab: 'maths',
  setActiveTab: (tab) => set({ activeTab: tab }),
}));